<template>
  <div class="mt-2">
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data v-else :references.sync="formReferences" :model="modelObj" ref="pwhtReference">
      <template v-if="modelObj.id && listOfDocuments.length > 0" slot="pwht_documents">
        <documents :documents="listOfDocuments" :deleteIds="deleteDocumentIds"></documents>
      </template>
    </form-data>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { hostAppApi } from '@/plugins/axios_settings'
import PermissionsMixin from '@/mixins/permissions'
import moment from 'moment'
export default {
  mixins: [PermissionsMixin],
  data () {
    return {
      listOfProjects: [],
      modelObj: {},
      loading: false,
      projectId: parseInt(this.$route.params.project_id) || 0,
      fieldsLoading: false,
      hostUserId: this.$cookie.get(process.env.VUE_APP_HOST_USER) ? this.$cookie.get(process.env.VUE_APP_HOST_USER) : 0,
      backUrl: '',
      listOfDocuments: [],
      deleteDocumentIds: [],
      hideDetails: true
    }
  },
  computed: {
    ...mapGetters(['formType', 'generalSettings', 'userDetails', 'getHostRefApi']),
    ...mapGetters('project', ['project']),
    formReferences () {
      return {
        cardFlat: true,
        cardTitleClass: 'pa-1',
        layoutClass: 'pa-1',
        title: this.modelObj.id ? this.$t('message.common.update') : `${this.$t('message.common.addNew')}`,
        properties: [{
          model: 'po_ranked',
          type: this.formType.TEXT,
          readonly: true,
          label: this.$t('message.projectFeature.poRanked'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'record_number',
          type: this.formType.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.projectFeature.recordNumber'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'location',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.deviation.location'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'chart_speed',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.chartSpeed'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'chart_number',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.chartNumber'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'ao_ranked',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.aoRanked'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'unrestricted_to',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.unrestrictedTo'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'restricted_rate_of_rise',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.restrictedRateOfRise'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'hold_temperature_required',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.holdTemperatureRequired'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'hold_temperature_actual',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.holdTemperatureActual'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'hold_time_actual',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.holdTimeActual'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'hold_time_required',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.holdTimeRequired'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'restricted_rate_down',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.restrictedRateDown'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'unrestricted_rate_of_fall',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.unrestrictedRateOfFall'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'files',
          type: this.formType.FILES,
          multiple: true,
          rules: this.$_maxFileSizeValidation(100, this.modelObj.files),
          label: this.$t('message.projectFeature.selectFiles'),
          class: 'xs12 sm4 md3',
          slot: 'pwht_documents',
          hideDetails: this.hideDetails
        }, {
          model: 'created_at',
          type: this.formType.DATEPICKER,
          rules: [],
          picker: 'weldDatePicker',
          menu: 'weldDateMenu',
          color: 'primary lighten-1',
          label: this.$t('message.projectFeature.weldDate'),
          class: 'xs12 sm6 md4 lg3'
        }, {
          model: 'performed_by',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.performedBy'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'approved_by',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.projectFeature.approvedBy'),
          class: 'xs12 sm4 md3 lg3'
        }, {
          model: 'approved_date',
          type: this.formType.DATEPICKER,
          rules: [],
          picker: 'approvedDatePicker',
          menu: 'approvedDateMenu',
          color: 'primary lighten-1',
          label: this.$t('message.projectFeature.approvedDate'),
          class: 'xs12 sm6 md4 lg3'
        }, {
          model: 'is_completed',
          rules: [],
          type: this.formType.CHECKBOX,
          class: 'xs12 sm6 md4 lg3 pt-2',
          label: this.$t('message.customModule.isCompleted')
        }],
        buttons: [{
          name: 'save_pwht',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'back',
          color: 'info',
          click: () => this.$router.go(-1), //  this.$router.push(this.backUrl),
          label: this.$t('message.login.back'),
          to: this.backUrl,
          is_show: true
        }]
      }
    }
  },
  mounted () {
    // set back url
    this.backUrl = this.projectId ? `/projects/${this.projectId}/pwht` : '/pwht'
    this.initializeFormData()
  },
  components: {
    'form-data': () => import('@/components/FormTemplate'),
    documents: () => import('@/components/Documents/Documents')
  },
  methods: {
    initializeFormData () {
      if (!this.project) return
      this.fieldsLoading = true
      this.modelObj = {
        po_ranked: this.project.number,
        project_id: this.projectId,
        created_at: moment().format('DD.MM.YYYY'),
        approved_date: moment().format('DD.MM.YYYY')
      }
      if (this.$route.params.id) {
        this.initializeEditData(this.$route.params.id)
        return
      }
      this.fieldsLoading = false
    },
    saveUpdateHandler () {
      if (this.$refs.pwhtReference.$refs.validateForm.validate()) {
        this.loading = true
        const files = this.modelObj.files
        const model = this.$formatter.cloneVariable(this.modelObj)
        model.user_id = parseInt(this.hostUserId)
        const formData = new FormData()
        if (files) {
          const Newfile = [...files]
          Newfile.forEach((file, i) => {
            formData.append('document[' + i + ']', file)
          })
        }
        delete model.created_at
        const newobj = this.$formatter.removeInvalidFromObject(model)
        setTimeout(() => {
          for (const key in newobj) {
            if (key !== 'files') formData.append(key, key === 'is_completed' ? newobj[key] : newobj[key] || null)
          }
          const header = {
            'Content-Type': 'multipart/form-data'
          }
          let url = this.getHostRefApi
          // const method = model.id ? 'put' : 'post'
          url += model.id ? `project_pwht/${model.id}/update` : 'project_pwht'
          const text = model.id ? 'message.common.updatedSuccess' : 'message.common.addedSucess'
          /* on update check if there is documents in array to delete */
          const ids = [...this.deleteDocumentIds]
          if (model.id && ids.length > 0) formData.append('document_delete_ids', ids)
          hostAppApi.post(url, formData, { headers: header }) // `${url}?locale=${this.$i18n.locale}`
            .then((response) => {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
              this.$router.push(this.backUrl)
            })
            .finally(() => {
              this.loading = false
            })
        }, 50)
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.validationIssue' })
    },
    initializeEditData (id) {
      this.fieldsLoading = true
      hostAppApi.get(`${this.getHostRefApi}project_pwht/${id}/edit?user_id=${this.hostUserId}&project_id=${this.projectId}`)
        .then((response) => {
          if (response.data) {
            const transformData = { date: { list: ['created_at', 'approved_date'], from: 'YYYY-MM-DD HH:mm:ss', to: 'DD.MM.YYYY' } }
            const model = this.$formatter.formatModel(response.data, transformData)
            this.modelObj = {
              ...this.modelObj,
              ...model
            }
            this.listOfDocuments = this.$formatter.removeInvalidFromArrayObject(this.modelObj.documents)
          }
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    }
  },
  watch: {
    isShowDocumentErrors (val) {
      this.hideDetails = !val
    }
  }
}
</script>

<style>

</style>
